import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { isEmpty } from "lodash";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { CONSTANT } from "src/app/constant";
import { DraftItem, InstructorOtherComments, InstructorOtherCommentsReg } from "src/app/models/models";
import { CbtaModalComponent } from "src/app/shared/components/cbta-modal/cbta-modal.component";
import { DraftService } from "src/app/shared/services/draft.service";
import { HttpService } from "src/app/shared/services/http.service";
import { LoaderService } from "src/app/shared/services/loader.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { UtilityService } from "src/app/util/utility.service";

@Component({
	selector: "app-other-training-observations",
	templateUrl: "./other-training-observations.component.html",
	styleUrls: ["./other-training-observations.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class OtherTrainingObservationsComponent implements OnInit {
	maneuverForm!: UntypedFormGroup;
	parentForm!: UntypedFormArray;
	parentFormArrayIndex: number = 0;
	@Input() tabIndex!: number;
	@Input("maneuverForm") set _(value: any) {
		this.maneuverForm = value as UntypedFormGroup;
	}

	otherTrainingComments: InstructorOtherComments[] = [];

	constructor(
		public sharedService: SharedService,
		private httpService: HttpService,
		private loadingService: LoaderService,
		private cd: ChangeDetectorRef,
		private dialog: MatDialog,
		private dbService: NgxIndexedDBService,
		private draftService: DraftService,
		private util: UtilityService,
	) {}

	ngOnInit(): void {
		this.parentForm = this.maneuverForm.parent as UntypedFormArray;
		this.parentFormArrayIndex = this.parentForm.controls.findIndex((subform) => subform == this.maneuverForm);

		this.maneuverForm?.valueChanges.subscribe((value: any) => {
			const options = this.sharedService.dropDownOptionsManeuver;

			if (!isEmpty(value)) {
				console.log("maneuver value", value);
				const maneuverOption = options.find((m) => m.code === value.maneuverCode);

				this.otherTrainingComments = [];

				this.otherTrainingComments.push({
					candidateId: value.candidateId,
					maneuver: maneuverOption?.description ?? "",
					maneuverCode: value.maneuverCode,
					comment: value.otherComents,
					createdAt: new Date().toISOString(),
				});
			}
		});
	}

	get inDraftMode(): boolean {
		return this.draftService.inDraftMode;
	}

	get isSynched(): boolean {
		return this.draftService.isSynced;
	}

	get formIndex() {
		return this.parentForm.controls.findIndex((subform) => subform == this.maneuverForm);
	}

	get maneuver() {
		return this.maneuverForm.get("maneuver")!;
	}

	get maneuverCode() {
		return this.maneuverForm.get("maneuverCode")!;
	}

	get assessmentId() {
		return this.maneuverForm.get("assessmentId")!;
	}

	get traineeAssessmentId() {
		return this.maneuverForm.get("traineeAssessmentId")!;
	}

	get candidateId() {
		return this.maneuverForm.get("candidateId")!;
	}

	get otherComents() {
		return this.maneuverForm.get("otherComents")!;
	}

	viewOtherSummaryModal() {
		const dialogRef = this.dialog.open(CbtaModalComponent, {
			panelClass: "view-summary-modal",
			height: "560px",
			width: "1154px",
			hasBackdrop: true,
			data: {
				modalTitle: "Other Training & Observations",
				modalName: "viewOtherSummaryModal",
				modalContent: this.otherTrainingComments,
				modalTraineeAssessmentId: this.traineeAssessmentId.value,
				noCloseBtn: true,
				modalBtnConfirmText: "Close",
			},
		});

		const sub = dialogRef.afterClosed().subscribe((a) => {
			sub.unsubscribe();
		});
	}

	onOtherTrainingCommentsAdded() {
		// const comment = this.otherComents?.value;
		this.otherCommentsModal();
	}

	otherCommentsModal() {
		console.log("otherCommentsModal", this.otherComents.value);
		const dialogRef = this.dialog.open(CbtaModalComponent, {
			panelClass: "other-comments-modal",
			height: "560px",
			width: "1140px",
			hasBackdrop: true,
			data: {
				modalName: "OtherCommentsModal",
				modalTitle: "Other Training & Observations",
				modalBtnConfirmText: "Save",
				modalBtnCancelText: "Cancel",
				disableClose: true,
				maneuverOtherComments: {
					otherComent: this.otherComents.value,
					maneuver: this.maneuver.value,
				},
			},
		});

		const sub = dialogRef.afterClosed().subscribe((result: { close: boolean; otherComments: string }) => {
			//

			if ((result?.otherComments || result?.otherComments === "") && result.close === true) {
				const data = {
					candidateId: this.candidateId.value,
					maneuverCode: this.maneuverCode.value,
					comment: result?.otherComments,
				} as InstructorOtherCommentsReg;

				const uidata = {
					candidateId: this.candidateId.value,
					maneuver: this.maneuver.value,
					maneuverCode: this.maneuverCode.value,
					comment: result.otherComments,
				} as InstructorOtherComments;

				//todo
				if (!navigator.onLine || this.inDraftMode) {
					this.otherComents.patchValue(result.otherComments);

					this.cd.detectChanges();
					this.dbService.getByID<DraftItem>(CONSTANT.INDEXEDDB.DRAFT, this.traineeAssessmentId.value).subscribe(
						(record) => {
							const candidateRating = record?.candidateRating ?? {};

							const otherComments = candidateRating?.otherComments ?? [];

							otherComments.push(data);

							this.dbService
								.update(CONSTANT.INDEXEDDB.DRAFT, {
									...record,
									candidateRating: {
										...candidateRating,
										otherComments,
									},
									lastUpdatedDate: new Date().toISOString(),
									continuePage: 2,
								})
								.subscribe(
									(result) => {
										console.log("rating updated", result);
										this.draftService.addToBeSynched("maneuver_comments", data);
										this.otherTrainingComments = [];
										this.otherTrainingComments.push(uidata);
									},
									(error) => {
										console.error(error);
									},
								);
						},
						(error) => {
							console.error(error);
						},
					);
				} else {
					this.loadingService.setLoading(true);
					this.httpService.instructorOtherComments(data).subscribe((resp: any) => {
						this.otherComents.patchValue(result.otherComments);

						this.otherTrainingComments = [];
						this.otherTrainingComments.push(uidata);

						const candidateRating = this.draftService.tempDraft?.candidateRating;
						// const toBeSynced = this.draftService.tempDraft?.toBeSynced ?? [];

						const otherComments = candidateRating?.otherComments ?? [];

						otherComments.push(data);

						// toBeSynced.push({
						//   eventName: 'maneuver_comments',
						//   body: data
						// })

						this.draftService.tempDraft = {
							candidateRating: {
								...candidateRating,
								otherComments,
							},
							// toBeSynced
						};

						this.loadingService.setLoading(false);
					});
				}
			}
			sub.unsubscribe();
		});
	}
}
